/**
 * Logos da marca — fonte única para os assets de logo.
 *
 * Por padrão usa os SVGs embutidos em src/assets/svg/ (marca "ecompay"), preservando o
 * comportamento atual sem configuração extra. Para trocar a marca sem rebuildar os assets,
 * defina as variáveis REACT_APP_BRAND_LOGO_*_URL apontando para uma imagem hospedada
 * (ex.: CDN, /public, etc.).
 *
 * Variantes:
 *  - LOGO            → logo completo (fundo claro)          REACT_APP_BRAND_LOGO_URL
 *  - LOGO_BLUE       → logo completo (versão azul/escura)   REACT_APP_BRAND_LOGO_BLUE_URL
 *  - LOGO_ICON       → apenas ícone                         REACT_APP_BRAND_LOGO_ICON_URL
 *  - LOGO_ICON_BLUE  → ícone (versão azul/escura)           REACT_APP_BRAND_LOGO_ICON_BLUE_URL
 */

import logoDefault from '../assets/svg/logo.svg';
import logoBlueDefault from '../assets/svg/logo-blue.svg';
import logoIconDefault from '../assets/svg/logo-icon.svg';
import logoIconBlueDefault from '../assets/svg/logo-icon-blue.svg';

const fallback = (value, def) =>
  value === undefined || value === null || value === '' ? def : value;

export const LOGO = fallback(process.env.REACT_APP_BRAND_LOGO_URL, logoDefault);
export const LOGO_BLUE = fallback(process.env.REACT_APP_BRAND_LOGO_BLUE_URL, logoBlueDefault);
export const LOGO_ICON = fallback(process.env.REACT_APP_BRAND_LOGO_ICON_URL, logoIconDefault);
export const LOGO_ICON_BLUE = fallback(
  process.env.REACT_APP_BRAND_LOGO_ICON_BLUE_URL,
  logoIconBlueDefault
);

const logos = { LOGO, LOGO_BLUE, LOGO_ICON, LOGO_ICON_BLUE };

export default logos;
